import React from 'react';

import useTranslation from '../../../hooks/useTranslation';
import { NoteTypes } from '../../../translations/translationType';

import './ToggleMessageInput.scss';

interface ToggleMessageInputProps {
    activeNoteType: NoteTypes;
    onChangeActiveNoteType: () => void;
}

const ToggleMessageInput = ({ activeNoteType, onChangeActiveNoteType }: ToggleMessageInputProps) => {
    const translated = useTranslation();
    const buttonTextID = activeNoteType === NoteTypes.MESSAGE ? 'switch-to-KID' : 'switch-to-message';
    const activeMessageTypeID = activeNoteType === NoteTypes.MESSAGE ? `message-active` : `KID-active`;
    return (
        <div className="message-toggle-wrapper">
            <span id="active-toggle-label" data-testid={activeMessageTypeID}>
                {translated.amountNote[activeNoteType].label}
            </span>
            <button
                type="button"
                className="message-toggle-button"
                onClick={onChangeActiveNoteType}
                data-testid={buttonTextID}
            >
                {activeNoteType === NoteTypes.MESSAGE ? translated.toggleKid : translated.toggleNote}
            </button>
        </div>
    );
};

export default ToggleMessageInput;
